import { render, staticRenderFns } from "./PastAdvisorCoreAnalyses.vue?vue&type=template&id=53d4f16c&scoped=true&"
import script from "./PastAdvisorCoreAnalyses.vue?vue&type=script&lang=js&"
export * from "./PastAdvisorCoreAnalyses.vue?vue&type=script&lang=js&"
import style0 from "./PastAdvisorCoreAnalyses.vue?vue&type=style&index=0&id=53d4f16c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d4f16c",
  null
  
)

export default component.exports